/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AILoadingButton from 'ai-components-ui-library/components/buttons/AILoadingButton';
import CopilotPreviewAutoGeneratedV2 from './CopilotPreviewAutoGeneratedV2';
import { useLocalSuperstore } from '../../../hooks/useLocalSuperstore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COPILOT_PREVIEW_CLOSED_STORAGE_KEY = 'COPILOT_PREVIEW_CLOSED';
export const CopilotPreviewThroughActionButton = ({
  actionButtonRef,
  aiTracker,
  autoGenerate,
  copilotAction,
  showAskAQuestionButton,
  summaryType,
  children,
  copilotActionButtonText,
  hasAIBadge,
  previewKey,
  previewSource,
  onClick,
  onClose,
  previewTitle,
  showCloseButton,
  onChatWithCopilot,
  onPositiveFeedback,
  onNegativeFeedback,
  onRefresh,
  onQuickActionClick,
  usageTrackerAppLocationKey,
  actionButtonLeftHeader,
  overrideDisabled,
  onDontShowAgain
}) => {
  const [displayCopilotPreview, setDisplayCopilotPreview] = useState(autoGenerate);
  const {
    localSuperstoreValue,
    localSuperstoreChecked,
    handleSetLocalSuperstoreValue
  } = useLocalSuperstore({
    key: `${COPILOT_PREVIEW_CLOSED_STORAGE_KEY}_${usageTrackerAppLocationKey}`
  });
  const handleClick = () => {
    handleSetLocalSuperstoreValue('false');
    setDisplayCopilotPreview(true);
    onClick === null || onClick === void 0 || onClick();
    aiTracker.track('Ai Addon Copilot Preview', 'Copilot Preview Interaction', {
      action: 'primary_action_click',
      command: JSON.stringify(copilotAction),
      isCopilotV2Enabled: true
    });
  };
  const handleClose = useCallback(() => {
    aiTracker.track('Ai Addon Copilot Preview', 'Copilot Preview Interaction', {
      action: 'close_preview',
      isCopilotV2Enabled: true
    });
    handleSetLocalSuperstoreValue('true');
    onClose === null || onClose === void 0 || onClose();
    setDisplayCopilotPreview(false);
  }, [handleSetLocalSuperstoreValue, onClose, aiTracker, setDisplayCopilotPreview]);
  const LoadingButton = () => {
    const loadingButton = /*#__PURE__*/_jsx(AILoadingButton, {
      buttonRef: actionButtonRef,
      loading: false,
      onClick: handleClick,
      size: "xs",
      usageTracker: aiTracker,
      use: "tertiary",
      children: copilotActionButtonText || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.buttonTitle"
      })
    });
    if (actionButtonLeftHeader) {
      return /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [actionButtonLeftHeader, loadingButton]
      });
    }
    return loadingButton;
  };

  // check to see what should be shown based on the local superstore value and state variable
  const shouldShowCopilotPreview = displayCopilotPreview || localSuperstoreChecked && localSuperstoreValue === 'false';
  if (!shouldShowCopilotPreview) {
    return /*#__PURE__*/_jsx(LoadingButton, {});
  }
  return /*#__PURE__*/_jsx(CopilotPreviewAutoGeneratedV2, {
    aiTracker: aiTracker,
    summaryType: summaryType,
    copilotAction: copilotAction,
    hasAIBadge: hasAIBadge,
    numHoursTilSummaryStale: 1,
    onChatWithCopilot: onChatWithCopilot,
    onNegativeFeedback: onNegativeFeedback,
    onPositiveFeedback: onPositiveFeedback,
    onQuickActionClick: onQuickActionClick,
    onRefresh: onRefresh,
    previewKey: previewKey,
    previewSource: previewSource,
    previewTitle: previewTitle,
    usageTrackerAppLocationKey: usageTrackerAppLocationKey,
    overrideDisabled: overrideDisabled,
    showCloseButton: showCloseButton,
    showAskAQuestionButton: showAskAQuestionButton,
    onCloseButtonClick: handleClose,
    onDontShowAgain: onDontShowAgain,
    children: children
  });
};